export const postLoginURL = `${process.env.REACT_APP_API_HOST}/login`;

export const getMeURL = `${process.env.REACT_APP_API_HOST}/me`;
export const postUpdatePassword = `${process.env.REACT_APP_API_HOST}/update-password`;


export const getPersonnelsURL = `${process.env.REACT_APP_API_HOST}/personnels`;
export const postPersonnelsURL = `${process.env.REACT_APP_API_HOST}/personnels`;
export const postUpdatePersonnelURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/personnels/${id}`;
}


export const getAuditorsURL = `${process.env.REACT_APP_API_HOST}/auditors`;
export const postAuditorsURL = `${process.env.REACT_APP_API_HOST}/auditors`;
export const postUpdateAuditorURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/auditors/${id}`;
}


export const getClerksURL = `${process.env.REACT_APP_API_HOST}/clerks`;
export const postClerksURL = `${process.env.REACT_APP_API_HOST}/clerks`;
export const postUpdateClerkURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/clerks/${id}`;
}

export const getMechanicsURL = `${process.env.REACT_APP_API_HOST}/mechanics`;
export const postMechanicsURL = `${process.env.REACT_APP_API_HOST}/mechanics`;
export const postUpdateMechanicURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/mechanics/${id}`;
}


export const getCashesTotalURL = `${process.env.REACT_APP_API_HOST}/cashes-total`;
export const getCashesURL = `${process.env.REACT_APP_API_HOST}/cashes`;
export const postCashesURL = `${process.env.REACT_APP_API_HOST}/cashes`;
export const postUpdateCashURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/cashes/${id}`;
}

export const getUsagesAllURL = `${process.env.REACT_APP_API_HOST}/usages-all`;
export const getUsagesURL = `${process.env.REACT_APP_API_HOST}/usages`;
export const postUsagesURL = `${process.env.REACT_APP_API_HOST}/usages`;
export const postUpdateUsageURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/usages/${id}`;
}

export const getCustomersURL = `${process.env.REACT_APP_API_HOST}/customers`;
export const postCustomersURL = `${process.env.REACT_APP_API_HOST}/customers`;
export const postUpdateCustomerURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/customers/${id}`;
}
export const getPublicServicesURL = `${process.env.REACT_APP_API_HOST}/public-services`;
export const getServicesURL = `${process.env.REACT_APP_API_HOST}/services`;
export const postServicesURL = `${process.env.REACT_APP_API_HOST}/services`;
export const postUpdateServiceURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/services/${id}`;
}

export const getSearchProductsURL = `${process.env.REACT_APP_API_HOST}/products-search`;
export const getProductsURL = `${process.env.REACT_APP_API_HOST}/products`;
export const postProductsURL = `${process.env.REACT_APP_API_HOST}/products`;
export const getProductsArchivesURL = `${process.env.REACT_APP_API_HOST}/products-archives`;
export const postUpdateProductURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/products/${id}`;
}
export const postArchiveProductURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/products/${id}/archive`;
}
export const postApproveArchiveURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/products/${id}/archive-approve`;
}
export const postDeclineArchiveURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/products/${id}/archive-decline`;
}


export const getStocksURL = `${process.env.REACT_APP_API_HOST}/stocks`;
export const postStocksURL = `${process.env.REACT_APP_API_HOST}/stocks`;
export const postUpdateStockURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/stocks/${id}`;
}

export const getMyOrdersURL = `${process.env.REACT_APP_API_HOST}/my-orders`;
export const getOrdersTotalURL = `${process.env.REACT_APP_API_HOST}/orders-total`;
export const getOrdersReportsURL = `${process.env.REACT_APP_API_HOST}/orders-reports`;
export const getOrdersMechanicReportsURL = `${process.env.REACT_APP_API_HOST}/orders-mechanic-reports`;
export const getOrdersMechanicSummaryURL = `${process.env.REACT_APP_API_HOST}/orders-mechanic-summary`;
export const getOrdersURL = `${process.env.REACT_APP_API_HOST}/orders`;
export const getOrdersByMechanicURL = `${process.env.REACT_APP_API_HOST}/orders-by-mechanic`;
export const postOrdersURL = `${process.env.REACT_APP_API_HOST}/orders`;

export const getOrderEditsURL = (orderId) => {
    return `${process.env.REACT_APP_API_HOST}/orders/${orderId}/edit`;
}
export const postOrderUpdatesURL = (orderId) => {
    return `${process.env.REACT_APP_API_HOST}/orders/${orderId}/update`;
}
export const postPaymentsURL = (orderId) => {
    return `${process.env.REACT_APP_API_HOST}/orders/${orderId}/payments`;
}
export const postOrderServicesURL = (orderId) => {
    return `${process.env.REACT_APP_API_HOST}/orders/${orderId}/services`;
}
export const postOrderCompleteURL = (orderId) => {
    return `${process.env.REACT_APP_API_HOST}/orders/${orderId}/complete`;
}
export const postEditPaymentURL = (paymentId) => {
    return `${process.env.REACT_APP_API_HOST}/payments/${paymentId}`;
}


export const getToolsURL = `${process.env.REACT_APP_API_HOST}/tools`;
export const postToolsURL = `${process.env.REACT_APP_API_HOST}/tools`;
export const postUpdateToolURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/tools/${id}`;
}


export const getLendsURL = `${process.env.REACT_APP_API_HOST}/lends`;
export const postLendsURL = `${process.env.REACT_APP_API_HOST}/lends`;
// export const postUpdateToolURL = (id) => {
//     return `${process.env.REACT_APP_API_HOST}/tools/${id}`;
// }
export const postLendsRemitURL = (id) => {
    return `${process.env.REACT_APP_API_HOST}/lends/${id}/remit`;
}